// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/management/api/tenant_plan.proto (package gx.management.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_management_resources_tenant_plan } from "../resources/tenant_plan_pb.js";
import { file_services_source_api_source } from "../../source/api/source_pb.js";

/**
 * Describes the file services/management/api/tenant_plan.proto.
 */
export const file_services_management_api_tenant_plan = /*@__PURE__*/
  fileDesc("CilzZXJ2aWNlcy9tYW5hZ2VtZW50L2FwaS90ZW5hbnRfcGxhbi5wcm90bxIRZ3gubWFuYWdlbWVudC5hcGkiFgoUR2V0VGVuYW50UGxhblJlcXVlc3QiUgoVR2V0VGVuYW50UGxhblJlc3BvbnNlEjkKBHBsYW4YASABKAsyKy5neC5tYW5hZ2VtZW50LnJlc291cmNlcy5UZW5hbnRQbGFuUmVzb3VyY2UiFwoVR2V0VGVuYW50VXNhZ2VSZXF1ZXN0InIKFkdldFRlbmFudFVzYWdlUmVzcG9uc2USFQoNaXNfb3Zlcl9saW1pdBgBIAEoCBJBCgxzb3VyY2VfdXNhZ2UYAiABKAsyKy5neC5zb3VyY2UuYXBpLkdldFRlbmFudFNvdXJjZVVzYWdlUmVzcG9uc2Uy3gEKEVRlbmFudFBsYW5TZXJ2aWNlEmIKDUdldFRlbmFudFBsYW4SJy5neC5tYW5hZ2VtZW50LmFwaS5HZXRUZW5hbnRQbGFuUmVxdWVzdBooLmd4Lm1hbmFnZW1lbnQuYXBpLkdldFRlbmFudFBsYW5SZXNwb25zZRJlCg5HZXRUZW5hbnRVc2FnZRIoLmd4Lm1hbmFnZW1lbnQuYXBpLkdldFRlbmFudFVzYWdlUmVxdWVzdBopLmd4Lm1hbmFnZW1lbnQuYXBpLkdldFRlbmFudFVzYWdlUmVzcG9uc2VC0wEKFWNvbS5neC5tYW5hZ2VtZW50LmFwaUIPVGVuYW50UGxhblByb3RvUAFaQ2dpdGh1Yi5jb20vZ2FsYXh5LWlvL2d4L3NoYXJlZC9nby9jb250cmFjdHMvc2VydmljZXMvbWFuYWdlbWVudC9hcGmiAgNHTUGqAhFHeC5NYW5hZ2VtZW50LkFwacoCEUd4XE1hbmFnZW1lbnRcQXBp4gIdR3hcTWFuYWdlbWVudFxBcGlcR1BCTWV0YWRhdGHqAhNHeDo6TWFuYWdlbWVudDo6QXBpYgZwcm90bzM", [file_services_management_resources_tenant_plan, file_services_source_api_source]);

/**
 * Describes the message gx.management.api.GetTenantPlanRequest.
 * Use `create(GetTenantPlanRequestSchema)` to create a new message.
 */
export const GetTenantPlanRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_tenant_plan, 0);

/**
 * Describes the message gx.management.api.GetTenantPlanResponse.
 * Use `create(GetTenantPlanResponseSchema)` to create a new message.
 */
export const GetTenantPlanResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_tenant_plan, 1);

/**
 * Describes the message gx.management.api.GetTenantUsageRequest.
 * Use `create(GetTenantUsageRequestSchema)` to create a new message.
 */
export const GetTenantUsageRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_tenant_plan, 2);

/**
 * Describes the message gx.management.api.GetTenantUsageResponse.
 * Use `create(GetTenantUsageResponseSchema)` to create a new message.
 */
export const GetTenantUsageResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_tenant_plan, 3);

/**
 * @generated from service gx.management.api.TenantPlanService
 */
export const TenantPlanService = /*@__PURE__*/
  serviceDesc(file_services_management_api_tenant_plan, 0);

